import * as React from "react";
import PodminkyPage from "../../../components/customOrgs/senzacni/PodminkyPage";

export default function Podminky() {
    return <PodminkyPage />;
}
